import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';

const normalizeCollectionOrderStatusLabel = (name?: string): string =>
  name
    ?.replace('Η Αίτηση', 'Το Αίτημα')
    .replace('η αίτηση', 'το αίτημα')
    .replace('Αίτησης', 'Αιτήματος')
    .replace('αίτησης', 'αιτήματος')
    .replace('Αίτηση', 'Αίτημα')
    .replace('αίτηση', 'αίτημα') ?? '';

export const exportColumns = (t) => {
  return [
    { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
    { fieldName: 'code', fieldTitle: t('Κωδικός Εντύπου'), fieldType: 'TEXT' },
    { fieldName: 'orderedDate', fieldTitle: t('Ημερομηνία Αιτήματος'), fieldType: 'DATE' },
    { fieldName: 'statusName', fieldTitle: t('Κατάσταση Αιτήματος'), fieldType: 'TEXT' },
    { fieldName: 'collectionDetails', fieldTitle: t('Σημείο Συλλογής '), fieldType: 'TEXT' },

    { fieldName: 'contactPerson', fieldTitle: t('Πρόσωπο Επικοινωνίας'), fieldType: 'TEXT' },
    { fieldName: 'collectionpoint.phone', fieldTitle: t('Τηλέφωνο'), fieldType: 'TEXT' },
    { fieldName: 'notes', fieldTitle: t('Σημειώσεις'), fieldType: 'TEXT' },

    {
      fieldName: 'collectionOrdersContainers',
      fieldTitle: t('Στοιχεία Συσκευασιών'),
      fieldType: 'TEXT',
    },
    { fieldName: 'userString1', fieldTitle: t('Δρομολόγιο'), fieldType: 'TEXT' },
    { fieldName: 'userDate1', fieldTitle: t('Ημερομηνία Δρομολογίου'), fieldType: 'DATE' },
    { fieldName: 'collector.name', fieldTitle: t('Συλλέκτης'), fieldType: 'TEXT' },
  ];
};

// export function useGetQuery(): any {
//   const [get, { loading }] = useLazyQuery(gqlGetQuery, { onCompleted: transformData });

//   const [result, setResult] = useState<any>([get, { loading, data: undefined }]);

//   function transformData(data) {
//     const recs = data.getFormsDefinitions.data.map(values => {
//       return {
//         ...values,
//         solvingPeriod: periodQtyUnitToString(values.solvingPeriodQty, values.solvingPeriodUnit),
//         restoringPeriod: periodQtyUnitToString(values.restoringPeriodQty, values.restoringPeriodUnit),
//         pausingPeriod: periodQtyUnitToString(values.pausingPeriodQty, values.pausingPeriodUnit),
//         repeatingPeriod: periodQtyUnitToString(values.repeatingPeriodQty, values.repeatingPeriodUnit),
//       };
//     });

//     const trsData = { getFormsDefinitions: { data: recs, recordCount: data?.getFormsDefinitions?.recordCount } };
//     setResult([get, { loading, data: trsData }]);
//   }

//   return result;
// }

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetQuery, { onCompleted: transformData });
    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);
    function transformData(data) {
      const recs = data.getCollectionOrders.data.map((values) => {
        return {
          ...values,
          statusName: normalizeCollectionOrderStatusLabel(values.collectionOrderState?.name),
          collectionDetails: values.collectionpoint
            ? `${values.collectionpoint.name ?? ''} - ${values.collectionpoint.address ?? ''}`
            : '',

          collectionOrdersContainers: values.collectionOrdersContainers
            ? values.collectionOrdersContainers
                .filter((container) => container.containersQty > 0) // Only include containers with Qty > 0
                .map(
                  (container) => `${container.containertype.name} (${container.containersQty} τμχ)`,
                ) // Format the string
                .join(', ') // Join the results with ', '
            : '',
        };
      });
      const trsData = {
        getCollectionOrders: { data: recs, recordCount: data?.getCollectionOrders?.recordCount },
      };
      setResult([get, { loading, data: trsData }]);
    }
    return result;
    //return [null, { loading: null, data: null }];
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'Orders',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}
